import {
  call, put, takeLatest,
} from 'redux-saga/effects';

import {
  GET_NOCONFORMIDADES_REQUEST,
  GET_NOCONFORMIDAD_REQUEST,
  CREATE_NOCONFORMIDAD_REQUEST,
  UPDATE_NOCONFORMIDAD_REQUEST,
  DELETE_PHOTO_NOCONFORMIDAD_REQUEST,
} from '../../actions/constants/noconformidades/noconformidades.constants';
import { authRequest } from '../../../helpers/request.helper';
import {
  addNotificacion,
} from '../../actions/creators/sistemaNotificaciones/notificaciones.actioncreator';
import {
  resetNoConformidades,
  getNoConformidadesAction,
  getNoConformidadesFailureAction,
  getNoConformidadesSuccessAction,
  seleccionarNoConformidadAction,
  getNoConformidadSuccessAction,
} from '../../actions/creators/noconformidades/noconformidades.actioncreator';


function* getNoConformidades(action) {
  try {
    const { payload } = action;
    const {
      page, start, limit, busqueda, archivado,
    } = payload;
    let url = `AplicacionesQ.noconformidades/?page=${page}&start=${start}&limit=${limit}&appAcceso=movil`;
    const filtros = [];
    const hayBusqueda = busqueda !== null && busqueda !== '';
    if (hayBusqueda) {
      filtros.push({
        property: 'busqueda', value: busqueda, operator: 'like',
      });
    }

    filtros.push({
      property: 'archivado', value: archivado, operator: 'eq',
    });

    const queryString = encodeURIComponent(JSON.stringify(filtros));
    url += `&filter=${queryString}`;
    const params = {
      url,
      method: 'GET',
    };

    const response = yield call(authRequest, params);
    const { datos, success, total } = response;
    if (success) {
      yield put(getNoConformidadesSuccessAction(datos, total, page, start, limit, hayBusqueda));
    } else {
      yield put(getNoConformidadesFailureAction());
    }
  } catch (error) {
    yield (put(addNotificacion('Sin conexión')));
  }
}

function* getNoConformidad(action) {
  try {
    const { payload } = action;
    const {
      id,
    } = payload;

    if (id !== null) {
      const params = {
        url: `AplicacionesQ.noconformidades/?id=${id}&appAcceso=movil`,
        method: 'GET',
      };

      const response = yield call(authRequest, params);
      const { datos: seleccionada, success } = response;
      if (success) {
        yield put(seleccionarNoConformidadAction(seleccionada));
      } else {
        yield put(getNoConformidadesFailureAction());
      }
    } else {
      yield put(seleccionarNoConformidadAction([]));
    }
  } catch (error) {
    yield (put(addNotificacion('Sin conexión')));
  }
}

function* crearNoConformidad(action) {
  const { payload } = action;
  const { form } = payload;
  const {
    nombre, observaciones, sede, coste, lote_producto: loteProducto, lote_proveedor: loteProveedor,
    unidades_afectadas: unidadesAfectadas, checkbox_sensible: checkboxSensible, reincidencia,
    revisar_riesgos_y_oportunidades: revisarRiesgosYOportunidades,
    requiere_cambios_sistema_gestion: requiereCambiosSistemaGestion, clientes, proveedores, rrhh,
    tipologias, usuario_id: usuarioId, fecha_creacion: fechaCreacion, procesos,
  } = form;
  let clientesSeleccionados = [];
  let proveedoresSeleccionados = [];
  let rrhhSeleccionados = [];
  let tipologiasSeleccionados = [];
  let procesosSeleccionados = [];
  const fechaArray = fechaCreacion.split('/');
  const fechaCreacionAux = new Date(fechaArray[2], fechaArray[1] - 1, fechaArray[0]);
  const fechaCreacionFormateada = `${fechaCreacionAux.getFullYear()}-${fechaCreacionAux.getMonth() + 1}-${fechaCreacionAux.getDate()}`;


  if (typeof (form) !== 'undefined') {
    if (clientes && (clientes.length > 0)) {
      clientesSeleccionados = clientes.map((item, i) => ({ id: i, value: item })).filter(item => item.value === true).map(item => item.id);
    }
    if (proveedores && (proveedores.length > 0)) {
      proveedoresSeleccionados = proveedores.map((item, i) => ({ id: i, value: item })).filter(item => item.value === true).map(item => item.id);
    }
    if (rrhh && (rrhh.length > 0)) {
      rrhhSeleccionados = rrhh.map((item, i) => ({ id: i, value: item })).filter(item => item.value === true).map(item => item.id);
    }
    if (tipologias && (tipologias.length > 0)) {
      tipologiasSeleccionados = tipologias.map((item, i) => ({ id: i, value: item })).filter(item => item.value === true).map(item => item.id);
    }
    if (procesos && (procesos.length > 0)) {
      procesosSeleccionados = procesos.map((item, i) => ({ id: i, value: item })).filter(item => item.value === true).map(item => item.id);
    }

    if (tipologiasSeleccionados.length === 0) {
      yield (put(addNotificacion('Debe seleccionar alguna tipología')));
      yield (put(getNoConformidadesFailureAction()));
    } else {
      const formData = new FormData();
      formData.append('id', null);
      formData.append('nombre', (nombre || ''));
      formData.append('nombre_modulo', 'noconformidad');
      formData.append('tipo_no_conformidad', 1);
      formData.append('observaciones', (observaciones || ''));
      formData.append('sede', (sede || 1));
      formData.append('coste', (coste || ''));
      formData.append('lote_producto', loteProducto || '');
      formData.append('lote_proveedor', loteProveedor || '');
      formData.append('unidades_afectadas', (unidadesAfectadas || null));
      formData.append('usuario_creacion', usuarioId);
      formData.append('fecha_creacion', fechaCreacionFormateada);
      if (checkboxSensible) {
        formData.append('checkbox_sensible', (checkboxSensible) ? 'on' : null);
      }
      if (reincidencia) {
        formData.append('reincidencia', (reincidencia) ? 'on' : null);
      }
      if (revisarRiesgosYOportunidades) {
        formData.append('revisar_riesgos_y_oportunidades', (revisarRiesgosYOportunidades) ? 'on' : null);
      }
      if (requiereCambiosSistemaGestion) {
        formData.append('requiere_cambios_sistema_gestion', (requiereCambiosSistemaGestion) ? 'on' : null);
      }
      formData.append('clientes', clientesSeleccionados.join(','));
      formData.append('proveedores', proveedoresSeleccionados.join(','));
      formData.append('usuarios_implicados', rrhhSeleccionados.join(','));
      formData.append('procedimientos', procesosSeleccionados.join(','));
      formData.append('tipologias', tipologiasSeleccionados.join(','));

      formData.append('observaciones_web', false);

      const params = {
        url: 'AplicacionesQ.noconformidades/create?appAcceso=movil',
        method: 'POST',
        body: formData,
      };

      const response = yield call(authRequest, params);
      const { nuevo_id: datos, success } = response;
      const { nuevo_id: nuevoId } = datos;
      if (success) {
        yield (put(resetNoConformidades()));
        yield (put(getNoConformidadesAction(1, 0, 25)));
        yield (put(getNoConformidadSuccessAction()));
        window.location.href = `${window.location.origin}/#/noconformidades/mostrar/${nuevoId}`;
      } else {
        yield (put(getNoConformidadesFailureAction()));
      }
    }
  }
}

function* actualizarNoConformidad(action) {
  const { payload } = action;
  const { form } = payload;
  const {
    id, nombre, observaciones, sede, coste, lote_producto: loteProducto,
    lote_proveedor: loteProveedor, unidades_afectadas: unidadesAfectadas,
    checkbox_sensible: checkboxSensible, reincidencia,
    revisar_riesgos_y_oportunidades: revisarRiesgosYOportunidades,
    requiere_cambios_sistema_gestion: requiereCambiosSistemaGestion, clientes, proveedores, rrhh,
    tipologias, usuario_id: usuarioId, fecha_creacion: fechaCreacion, procesos,
    observaciones_fotos: observacionesFotos, observaciones_web: observacionesWeb,
  } = form;
  let clientesSeleccionados = [];
  let proveedoresSeleccionados = [];
  let rrhhSeleccionados = [];
  let tipologiasSeleccionados = [];
  let procesosSeleccionados = [];
  let observacionesCompletas = observaciones;

  if (observacionesFotos) {
    observacionesCompletas = observacionesFotos.replace(/<img /g, '<br><br> <img ');
  }

  const fechaArray = fechaCreacion.split('/');
  const fechaCreacionAux = new Date(fechaArray[2], fechaArray[1] - 1, fechaArray[0]);
  const fechaCreacionFormateada = `${fechaCreacionAux.getFullYear()}-${fechaCreacionAux.getMonth() + 1}-${fechaCreacionAux.getDate()}`;

  if (typeof (form) !== 'undefined') {
    if (clientes && (clientes.length > 0)) {
      clientesSeleccionados = clientes.map((item, i) => ({ id: i, value: item })).filter(item => item.value === true).map(item => item.id);
    }
    if (proveedores && (proveedores.length > 0)) {
      proveedoresSeleccionados = proveedores.map((item, i) => ({ id: i, value: item })).filter(item => item.value === true).map(item => item.id);
    }
    if (rrhh && (rrhh.length > 0)) {
      rrhhSeleccionados = rrhh.map((item, i) => ({ id: i, value: item })).filter(item => item.value === true).map(item => item.id);
    }
    if (tipologias && (tipologias.length > 0)) {
      tipologiasSeleccionados = tipologias.map((item, i) => ({ id: i, value: item })).filter(item => item.value === true).map(item => item.id);
    }
    if (procesos && (procesos.length > 0)) {
      procesosSeleccionados = procesos.map((item, i) => ({ id: i, value: item })).filter(item => item.value === true).map(item => item.id);
    }

    if (tipologiasSeleccionados.length === 0) {
      yield (put(addNotificacion('Debe seleccionar alguna tipología')));
      yield put(getNoConformidadesFailureAction());
    } else {
      const formData = new FormData();
      formData.append('id', id);
      formData.append('nombre', nombre);
      formData.append('nombre_modulo', 'noconformidad');
      formData.append('tipo_no_conformidad', 1);
      formData.append('observaciones', observacionesCompletas);
      formData.append('sede', sede);
      formData.append('coste', coste);
      formData.append('lote_producto', loteProducto || '');
      formData.append('lote_proveedor', loteProveedor || '');
      formData.append('unidades_afectadas', (unidadesAfectadas || null));
      formData.append('usuario_creacion', usuarioId);
      formData.append('fecha_creacion', fechaCreacionFormateada);
      if (checkboxSensible) {
        formData.append('checkbox_sensible', (checkboxSensible) ? 'on' : null);
      }
      if (reincidencia) {
        formData.append('reincidencia', (reincidencia) ? 'on' : null);
      }
      if (revisarRiesgosYOportunidades) {
        formData.append('revisar_riesgos_y_oportunidades', (revisarRiesgosYOportunidades) ? 'on' : null);
      }
      if (requiereCambiosSistemaGestion) {
        formData.append('requiere_cambios_sistema_gestion', (requiereCambiosSistemaGestion) ? 'on' : null);
      }
      formData.append('clientes', clientesSeleccionados.join(','));
      formData.append('proveedores', proveedoresSeleccionados.join(','));
      formData.append('usuarios_implicados', rrhhSeleccionados.join(','));
      formData.append('procedimientos', procesosSeleccionados.join(','));
      formData.append('tipologias', tipologiasSeleccionados.join(','));

      formData.append('observaciones_web', observacionesWeb);

      const params = {
        url: 'AplicacionesQ.noconformidades/update?appAcceso=movil',
        method: 'POST',
        body: formData,
      };

      const response = yield call(authRequest, params);
      const { id: datos, success } = response;
      const { id: idEdicion } = datos;
      if (success) {
        yield (put(resetNoConformidades()));
        yield (put(getNoConformidadesAction(1, 0, 25)));
        yield (put(getNoConformidadSuccessAction()));
        window.location.href = `${window.location.origin}/#/noconformidades/mostrar/${idEdicion}`;
      } else {
        yield (put(getNoConformidadesFailureAction()));
      }
    }
  }
}

function* eliminarFotoNoConformidad(action) {
  const { payload } = action;
  const { form } = payload;
  const { nc_id: ncId, foto } = form;

  const formData = new FormData();
  formData.append('foto', foto);
  formData.append('nc_id', ncId);

  const params = {
    url: 'AplicacionesQ.noconformidades/eliminarFoto',
    method: 'POST',
    body: formData,
  };

  const response = yield call(authRequest, params);
  const { id, success } = response;
  if (success) {
    window.location.href = `${window.location.origin}/#/noconformidades/editar/${id}`;
  }
}


export function* getNoConformidadesRequest() {
  yield takeLatest(GET_NOCONFORMIDADES_REQUEST, getNoConformidades);
}

export function* getNoConformidadRequest() {
  yield takeLatest(GET_NOCONFORMIDAD_REQUEST, getNoConformidad);
}

export function* crearNoConformidadRequest() {
  yield takeLatest(CREATE_NOCONFORMIDAD_REQUEST, crearNoConformidad);
}

export function* actualizarNoConformidadRequest() {
  yield takeLatest(UPDATE_NOCONFORMIDAD_REQUEST, actualizarNoConformidad);
}

export function* eliminarFotoNoConformidadRequest() {
  yield takeLatest(DELETE_PHOTO_NOCONFORMIDAD_REQUEST, eliminarFotoNoConformidad);
}
